import React from 'react';
import { Tooltip } from 'reactstrap';

export interface InventoryClickIconProps {
    id: number;
    onClick: React.Dispatch<React.SetStateAction<number>>;
    shouldDisplay: boolean;
}

const InventoryClickIcon: React.FC<InventoryClickIconProps> = ({ id, onClick, shouldDisplay }) => {
    const [tooltipOpen, setTooltipOpen] = React.useState(false);
    const toggleTooltip = () => setTooltipOpen(open => !open);

    if (!shouldDisplay) {
        return null;
    }

    const targetId = `Tooltip-${id}`;

    return (
        <div className='inventory-tooltip'>
            <span
                id={targetId}
                onClick={() => {
                    setTooltipOpen(false);
                    onClick(id);
                }}
                data-toggle='tooltip'
            >
                <svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 30 30'>
                    <path d='M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16,21h-2v-7h2V21z M15,11.5 c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S15.828,11.5,15,11.5z'></path>
                </svg>
            </span>
            <Tooltip isOpen={tooltipOpen} target={targetId} toggle={toggleTooltip} placement='right' className='custom-tooltip'>
                Check availability
            </Tooltip>
        </div>
    );
};

export default InventoryClickIcon;
